// @flow
import type {Node} from 'react'
import React from 'react'
import ArrowUp from 'components/ui/icons/ios/ArrowUp'
import ArrowDown from 'components/ui/icons/ios/ArrowDown'
import IconButton from 'components/SideBar/ui/IconButton'

type Props = $ReadOnly<{
  isCollapsed: boolean,
  onToggle: () => void,
}>

function ToggleButton({isCollapsed, onToggle}: Props): Node {
  return (
    <IconButton
      alt={isCollapsed ? I18n.t('side_nav.open') : I18n.t('side_nav.close')}
      onClick={onToggle}
      size="xs"
    >
      {isCollapsed
        ? <ArrowDown />
        : <ArrowUp />
    }
    </IconButton>
  )
}

export default ToggleButton
